const Agreement =()=> {
    return (
        'Content coming soon'
    )
}

export default Agreement;